// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jdp2HifDAgUgsM {
  display: flex;
  gap: var(--ds-space-050, 4px);
  /* Hide default HTML checkbox */
  /* The slider */
}
.Jdp2HifDAgUgsM .x2WuOrGSFco5w1 {
  margin-right: var(--ds-space-050, 4px);
}
.Jdp2HifDAgUgsM .WodOa5ceVoRcyP {
  margin: var(--ds-space-0, 0);
  margin-right: var(--ds-space-050, 4px);
}
.Jdp2HifDAgUgsM .BfZvGCHx5gLNPZ,
.Jdp2HifDAgUgsM .NzIjJ4xCkJVaMo {
  font-weight: var(--ds-font-weight-bold, bold);
}
.Jdp2HifDAgUgsM .eyRQNITywxc3YG {
  display: inline-block;
  position: relative;
  width: 32px;
  height: 16px;
  margin: var(--ds-space-050, 3px) var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.Jdp2HifDAgUgsM .eyRQNITywxc3YG:focus-within {
  border-radius: var(--ds-border-radius-200, 8px);
  box-shadow: 0 0 0 2px var(--ds-border-focused, #388bff);
}
.Jdp2HifDAgUgsM .eyRQNITywxc3YG input {
  width: 0;
  height: 0;
  opacity: 0;
}
.Jdp2HifDAgUgsM .AnvACxh4ApfDu2 {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  transition: 0.4s;
  border-radius: 32px;
  background-color: var(--ds-background-accent-green-subtle, #4bce97);
  cursor: pointer;
}
.Jdp2HifDAgUgsM .AnvACxh4ApfDu2::before {
  content: '';
  position: absolute;
  top: var(--ds-space-025, 2px);
  bottom: var(--ds-space-050, 4px);
  left: var(--ds-space-025, 2px);
  width: 12px;
  height: 12px;
  transition: 0.4s;
  border-radius: var(--ds-border-radius-circle, 50%);
  background-color: var(--ds-surface, #ffffff);
}
.Jdp2HifDAgUgsM input:checked + .AnvACxh4ApfDu2 {
  background-color: var(--ds-background-accent-green-subtle, #4bce97);
}
.Jdp2HifDAgUgsM input:focus + .AnvACxh4ApfDu2 {
  box-shadow: 0 0 1px var(--ds-background-accent-green-subtle, #4bce97);
}
.Jdp2HifDAgUgsM input:disabled + .AnvACxh4ApfDu2 {
  background-color: var(--ds-background-disabled, #091e4208);
}
.Jdp2HifDAgUgsM input:checked + .AnvACxh4ApfDu2::before {
  transform: translateX(16px);
}
`, ""]);
// Exports
export var toggleWrapper = `Jdp2HifDAgUgsM`;
export var primaryLabel = `x2WuOrGSFco5w1`;
export var label = `WodOa5ceVoRcyP`;
export var leftLabel = `BfZvGCHx5gLNPZ`;
export var rightLabel = `NzIjJ4xCkJVaMo`;
var _1 = `eyRQNITywxc3YG`;
export { _1 as "switch" };
export var slider = `AnvACxh4ApfDu2`;
export default ___CSS_LOADER_EXPORT___;
